import { render, staticRenderFns } from "./Modal.vue?vue&type=template&id=f126177c&"
import script from "./Modal.vue?vue&type=script&lang=js&"
export * from "./Modal.vue?vue&type=script&lang=js&"
import style0 from "./Modal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "Modal.vue"
export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/components/Modal.vue
// module id = 1637
// module chunks = 1